import 'intersection-observer'
import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import './index.css'
import App from './components/App/App'
// import registerServiceWorker from './registerServiceWorker'
import smoothscroll from 'smoothscroll-polyfill'

import "@fontsource/pt-sans"
import "@fontsource/pt-sans/400-italic.css"
import "@fontsource/pt-sans/700.css"
import "@fontsource/pt-sans/700-italic.css"

smoothscroll.polyfill()

// hot-reloading App-component:
if (module.hot) {
  module.hot.accept()
}

ReactDOM.render((
  <BrowserRouter>
    <App/>
  </BrowserRouter>
), document.getElementById('root'))

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js